import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import { IHubVehicle } from "interfaces/Hub";
import { Button } from "components/ui/ButtonGs";
import { useMutation, useQueryClient } from "react-query";
import { useHubVehicle } from "hooks/api";
import { useErrorHandler } from "exceptions/ErrorHandler";
import { toast } from "sonner";
interface IDeleteProps {
  isOpen: boolean;
  data: IHubVehicle;
  onClose: () => void;
}
export const HubDeleteVehicle: React.FC<IDeleteProps> = ({
  isOpen,
  data,
  onClose,
}) => {
  const { deleteVehicle } = useHubVehicle();
  const { errorHandler } = useErrorHandler();
  const queryClient = useQueryClient();
  const mutation = useMutation(() => deleteVehicle(data.id), {
    onSuccess: () => {
      queryClient.invalidateQueries("deleteVehicle");
      toast.success("Motorista removida com sucesso");
      onClose();
    },
    onError: (error) => {
      errorHandler(error);
    },
  });

  const handleConfirm = () => {
    mutation.mutate();
  };
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-GilroyBold text-lg tracking-normal">
            Você tem certeza dessa exclusão?
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <article className="mb-4">
            Está é uma ação irreversível, caso você tenha certeza que deseja
            excluir o veiculo, clique no botão{" "}
            <span className="font-bold">Deletar</span>. Caso contrário, clique
            no botão <span className="font-bold">cancelar</span>.
          </article>
          <div className="bg-slate-100 p-4 border-slate-300 rounded-sm text-sm font-medium shadow-inner">
            Excluir:{" "}
            <span className="text-red-500">{`Placa: ${data.vehicle_plate} - Renavam ${data.renavam}`}</span>
          </div>
        </DialogDescription>
        <DialogFooter>
          <Button.Root size="sm" variant="secondary" onClick={onClose}>
            Cancelar
          </Button.Root>
          <Button.Root
            size="sm"
            variant="danger"
            onClick={() => handleConfirm()}
            disabled={mutation.isLoading}
          >
            Deletar
          </Button.Root>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
